import { Component } from 'react'
class ErrorBoundary extends Component {
  constructor(props: any) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    })
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div>
          <h2>Error Loading Image</h2>
        </div>
      )
    }
    return this.props.children
  }
}
export { ErrorBoundary }
